import { useChatboxStateContext } from "../../context/ChatboxContext"
import { useConversationStateContext } from "../../context/ConversationContext";
import { useState, useEffect, useRef } from "react";
import ChatboxPath from "./ChatboxPath";
function ChatboxPathContainer() {
    const { valueTogglePath } = useChatboxStateContext();
    const { path } = useConversationStateContext();
    const [display, setDisplay] = useState(valueTogglePath == false ? 'none' : 'flex');
    const isInitialMount = useRef(true);
    var blocks = [];
    if (path != null) {
        blocks = path.map(block_id => window.getBlockInformation(block_id));
    }
    const [selectedObject, setSelectedObject] = useState(blocks[blocks.length - 1]?.object_id)
    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return
        }

        valueTogglePath == true ? setDisplay('flex') : setTimeout(() => setDisplay('none'), 350)
    }, [valueTogglePath])


    return (
        <div className={valueTogglePath ? "kwalys-chatbox-path visible" : "kwalys-chatbox-path"} style={{ display }}>
            <h3>
                Path
            </h3>
            <div className="kwalys-list-variable scrollbar-chatbox">
                {display == 'flex' && blocks.length > 0 && blocks.map((block, index) =>
                    <ChatboxPath block={block.block} key={index} selected={selectedObject == block.block?.object_id} setSelectedObject={setSelectedObject} />)
                }
            </div>
        </div>
    )
}

export default ChatboxPathContainer;